import { render, staticRenderFns } from "./CraftTreeLevel.vue?vue&type=template&id=3570ae92&scoped=true&"
import script from "./CraftTreeLevel.vue?vue&type=script&lang=ts&"
export * from "./CraftTreeLevel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3570ae92",
  null
  
)

export default component.exports